var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconComprovante = function SvgIconComprovante(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142.245,
    height: 160,
    viewBox: "0 0 142.245 160",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9505",
    "data-name": "Grupo 9505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5929",
    "data-name": "Caminho 5929",
    d: "M77.464,4H-29.219C-39.039,4-47,11.542-47,20.84V164l24.448-12.631L1.9,164l22.226-12.631L46.361,164,70.81,151.369,95.245,164V20.84C95.245,11.542,87.283,4,77.464,4Zm8.89,145.4-11.46-5.924L70.81,141.36l-4.081,2.111L46.561,153.889,28.514,143.64l-4.392-2.493L19.73,143.64,1.7,153.889l-20.168-10.418-4.081-2.107-4.081,2.107L-38.11,149.4V20.84c0-4.382,3.987-7.951,8.89-7.951H77.464c4.9,0,8.89,3.569,8.89,7.951Z",
    transform: "translate(47 -4)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5930",
    "data-name": "Caminho 5930",
    d: "M-37.555,19.89H6.9A4.445,4.445,0,1,0,6.9,11H-37.555A4.444,4.444,0,0,0-42,15.445,4.444,4.444,0,0,0-37.555,19.89Z",
    transform: "translate(64.226 20.111)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5931",
    "data-name": "Caminho 5931",
    d: "M51.348,23h-88.9A4.444,4.444,0,0,0-42,27.445a4.444,4.444,0,0,0,4.445,4.445h88.9a4.445,4.445,0,1,0,0-8.89Z",
    transform: "translate(64.226 61.444)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5932",
    "data-name": "Caminho 5932",
    d: "M51.348,17h-88.9A4.444,4.444,0,0,0-42,21.445a4.444,4.444,0,0,0,4.445,4.445h88.9a4.445,4.445,0,1,0,0-8.89Z",
    transform: "translate(64.226 40.777)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5933",
    "data-name": "Caminho 5933",
    d: "M51.348,29h-88.9A4.441,4.441,0,0,0-42,33.445a4.441,4.441,0,0,0,4.445,4.445h88.9a4.445,4.445,0,1,0,0-8.89Z",
    transform: "translate(64.226 82.11)",
    fill: "#191750"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconComprovante, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_comprovante.52cab523.svg";
export { ForwardRef as ReactComponent };